import gql from "graphql-tag";
import {responseField} from "../../base.graphql";

export const attachmentGqlFields = `
  filePath
  fileName
  base64String
`;


export const READ_ATTACHMENT_BY_PATH = gql`
  query GetBase64File($filePath: String!) {
    getBase64File(filePath: $filePath) {
        response {
          ${responseField}
        }
        data {
          ${attachmentGqlFields}
        }
    }
  }
`;


export const UPLOAD_ATTACHMENT = gql`
  mutation UploadBase64File($input: Base64FileInputObjects!) {
    uploadBase64File(input: $input) {
      response {
        ${responseField}
      }
      data {
        ${attachmentGqlFields}
      }
    }
  }
`;
